import { createAsyncThunk } from '@reduxjs/toolkit';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/dashboard/dashboard.response.type';
import * as Request from '@shared/models/dashboard/dashboard.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';
import { setHelpCenterFaqs } from '../slices/helpcenter.slice';

export const HelpCenterEndpoints = {
    helpCenter: config.base_url + '/dashboard/help',
};

export const fetchHelpCenterFaqs = createAsyncThunk<void, Request.IFaqsQueryType>(
    HelpCenterEndpoints.helpCenter,
    async (query, { dispatch }) => {
        try {
            const { type } = query.params;
            const params = query.params ? new URLSearchParams({ type }) : '';
            const res = await httpService.get<AscResponse<Response.IFaqsResponseType>>(
                `${HelpCenterEndpoints.helpCenter}?${params}`
            );

            dispatch(setHelpCenterFaqs(res.data.data));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(err, `Error fetching FAQs of help center, query: ${HelpCenterEndpoints.helpCenter}`),
                { type: 'error' }
            );
        }
    }
);

export const sendInquiry = createAsyncThunk<void, Request.ISendInquiryQueryType>(
    HelpCenterEndpoints.helpCenter + '/inquiry',
    async (query, { dispatch }) => {
        try {
            const res = await httpService.post<AscResponse<{ isAdded: boolean }>>(
                `${HelpCenterEndpoints.helpCenter}?type=${query.params.type}`,
                {
                    message: query.params.message,
                }
            );

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(formatErrorMessage(err, `Error sending an inquiry, query ${HelpCenterEndpoints.helpCenter}`), {
                type: 'error',
            });
        }
    }
);
